import React from 'react';
import { Chip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const PALETTE = {
  active: { bg: 'rgba(16,185,129,0.12)', fg: '#047857', label: 'Actif' },
  inactive: { bg: 'rgba(148,163,184,0.18)', fg: '#475569', label: 'Inactif' },
  pending: { bg: 'rgba(245,158,11,0.14)', fg: '#b45309', label: 'En attente' },
  approved: { bg: 'rgba(16,185,129,0.12)', fg: '#047857', label: 'Approuvé' },
  rejected: { bg: 'rgba(239,68,68,0.14)', fg: '#b91c1c', label: 'Rejeté' },
  cancelled: { bg: 'rgba(239,68,68,0.14)', fg: '#b91c1c', label: 'Annulé' },
  completed: { bg: 'rgba(99,102,241,0.14)', fg: '#3730a3', label: 'Terminé' },
  in_progress: { bg: 'rgba(14,165,233,0.14)', fg: '#075985', label: 'En cours' },
  paid: { bg: 'rgba(16,185,129,0.12)', fg: '#047857', label: 'Payé' },
  failed: { bg: 'rgba(239,68,68,0.14)', fg: '#b91c1c', label: 'Échoué' },
  verified: { bg: 'rgba(16,185,129,0.12)', fg: '#047857', label: 'Vérifié' },
  unverified: { bg: 'rgba(245,158,11,0.14)', fg: '#b45309', label: 'Non vérifié' },
  default: { bg: 'rgba(148,163,184,0.18)', fg: '#334155', label: '—' },
};

const StyledChip = withStyles({
  root: {
    height: 26,
    fontSize: '0.75rem',
    fontWeight: 700,
    letterSpacing: '0.02em',
    borderRadius: 999,
    padding: '0 4px',
  },
})(Chip);

const StatusChip = ({ status, label, ...props }) => {
  const key = (status || '').toString().toLowerCase().replace(/\s/g, '_');
  const cfg = PALETTE[key] || PALETTE.default;
  return (
    <StyledChip
      size="small"
      label={label || cfg.label || status || '—'}
      style={{ backgroundColor: cfg.bg, color: cfg.fg }}
      {...props}
    />
  );
};

export default StatusChip;
